<template>
    <div v-if="tournoi" class="sarticle">
        <div v-if="!isPreinscrit">
            Vous pouvez vous préinscrire au tournoi  <div><b>{{formatDate(tournoi.date)}} {{tournoi.description}}</b> </div>
            Votre inscription sera définitive dès que l'organisateur confirmera votre participation
            <div class="sbutton">
                <s-button label="Demande d'inscription" icon="signature" theme="is-primary is-medium" 
                @onclick="presinscription()"/>
            </div>
        </div>
        <div v-if="isPreinscrit">
            Vous êtes êtes préinscrit au tournoi  <div><b>{{formatDate(tournoi.date)}} {{tournoi.description}}</b> </div>
            L'organisateur doit confirmer votre participation
            <div class="sbutton">
                <s-button label="Se désinscription" icon="trash" theme="is-danger is-medium" 
                @onclick="desinscription()" v-if="tournoi.options.unsubscribe" />
            </div>
        </div>
    </div>
</template>
<style  scoped>
    .sarticle {
        padding: 10px;
        font-size: 25px;
        color: black;
        position: relative;
    }
    .sbutton {
        padding-top: 20px;
        padding-bottom: 20px;
        
    }
    
</style>
<script>
import tournoi_fct from "@/firebase/tournoi";
export default {
    props: ["joueur", "club", "tournoi"],
    computed: {
        isPreinscrit() {
            if (typeof(this.tournoi.preinscription) != "undefined")
                return this.tournoi.preinscription.indexOf(this.joueur.id) != -1;
            else
                return false;
        }
    },
    methods: {
        presinscription() {
            if (typeof(this.tournoi.preinscription) == "undefined")
                this.tournoi.preinscription = [];
            if (this.tournoi.preinscription.indexOf(this.joueur.id) == -1)
                this.tournoi.preinscription.push(this.joueur.id);
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{});
        },
        desinscription() {
            if (typeof(this.tournoi.preinscription) == "undefined")
                this.tournoi.preinscription = [];
            var indexJoueur = this.tournoi.preinscription.indexOf(this.joueur.id) == -1;
            this.tournoi.preinscription.splice(indexJoueur, 1);
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{});
        },
        formatDate(date) {
                var options = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
                return (new Date(date)).toLocaleString("fr-Fr",options);
            },
    }
}
</script>